import { Instance } from 'mobx-state-tree';
import { BulkDeleteVisitsResultDtoModelBase } from './BulkDeleteVisitsResultDtoModel.base';

/* The TypeScript type of an instance of BulkDeleteVisitsResultDtoModel */
export interface BulkDeleteVisitsResultDtoModelType extends Instance<typeof BulkDeleteVisitsResultDtoModel.Type> {}

/* A graphql query fragment builders for BulkDeleteVisitsResultDtoModel */
export { selectFromBulkDeleteVisitsResultDto, bulkDeleteVisitsResultDtoModelPrimitives, BulkDeleteVisitsResultDtoModelSelector } from './BulkDeleteVisitsResultDtoModel.base';

/**
 * BulkDeleteVisitsResultDtoModel
 */
export const BulkDeleteVisitsResultDtoModel = BulkDeleteVisitsResultDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
